import React from 'react';
import { Button } from 'reactstrap';

interface PropTypes {}

export function JobOrganicPostsDetails(_props: PropTypes) {
  return (
    <div className='border border-blue-gray-500 rounded-3 p-4'>
      <div className='d-flex flex-nowrap justify-content-between mb-4'>
        <h3>Job Posting details</h3>
        <div className='d-flex gap-2'>
          <Button color='danger' size='sm'>
            Cancel
          </Button>
          <Button color='primary' size='sm'>
            Save
          </Button>
        </div>
      </div>
    </div>
  );
}
